import type { ColumnDef } from "@tanstack/react-table";
import EmptyState from "@/components/EmptyState";
import Table from "@/components/Table";
import { toFormat } from "@/lib/dateHelpers";
import type { MembershipApplicationChangelog } from "../queries";

interface ChangeHistoryRow {
  id: string;
  description: string;
  timestamp: string;
  modifiedBy: string;
}

const changeHistoryColumns: ColumnDef<ChangeHistoryRow, unknown>[] = [
  {
    accessorKey: "description",
    header: "Description",
    enableSorting: false,
    meta: { headerClassName: "hide-header-in-column" }
  },
  {
    accessorKey: "timestamp",
    header: "Timestamp",
    enableSorting: false
  },
  {
    accessorKey: "modifiedBy",
    header: "Modified By",
    enableSorting: false
  }
];

function toRows(changelogs: MembershipApplicationChangelog[]): ChangeHistoryRow[] {
  return changelogs.map((entry) => ({
    id: String(entry.id),
    description: entry.description,
    timestamp: toFormat(entry.timestamp, "MMM dd, yyyy h:mm a") || "--",
    modifiedBy: entry.modifiedBy || "--"
  }));
}

export interface ApplicationChangeHistoryProps {
  changelogs: MembershipApplicationChangelog[];
}

export default function ApplicationChangeHistory({ changelogs }: ApplicationChangeHistoryProps) {
  const rows = toRows(changelogs);

  return (
    <Table
      data={rows}
      columns={changeHistoryColumns}
      loading={false}
      renderNoDataEmptyState={() => (
        <EmptyState
          iconName="history"
          title="No Change History Yet"
          caption="Updates to this application will appear here as they happen."
        />
      )}
    />
  );
}
